﻿(function (angular, parseInt, location, history, ToyotaConsts) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyPressListing", [
    function () {
      var controller = [
        "$filter",
        "$analytics",
        "API",
        "$attrs",
        function ($filter, $analytics, API, $attrs) {
          var ctl = this;
          ctl.category = "all";
          ctl.busy = true;

          var items = {
            currentItems: [],
            prefetchItems: [],
            apiCall: null,
            broadcast: false,
          };

          var listingOptions = {
            url: ToyotaConsts.API.News.PressListings,
            pageNumber: 1,
            category: ctl.category,
          };

          var listingParams = {
            pageNumber: listingOptions.pageNumber,
            category: listingOptions.category,
            currentPage: $attrs.currentSiteName,
            siteId: $attrs.siteId,
          };

          init(); // call init function

          function init() {
            ctl.items = [];
            ctl.prescrollToItemIndex = parseInt(location.hash.substring(1));

            getInitialItems().then(function () {
              if (items.currentItems.Remaining > 0) {
                getPrefetchItems().then(function () {
                  if (!isNaN(ctl.prescrollToItemIndex)) {
                    getMoreItems(ctl.prescrollToItemIndex);
                  }
                });
              }
            });
          }

          function getInitialItems() {
            return getItems($filter("formatArgs")(listingOptions.url, listingParams)).then(function (fetchedItems) {
              ctl.items = fetchedItems;
              items.currentItems = fetchedItems;
            });
          }

          function getItems(url) {
            ctl.busy = true;
            abortApiCall();
            return (items.apiCall = API.get(url)).then(function (response) {
              if (angular.isDefined(response)) {
                ctl.busy = false;
                return response.data;
              }

              return undefined;
            });
          }

          function abortApiCall() {
            return items.apiCall && items.apiCall.cancel();
          }

          function getPrefetchItems() {
            listingParams.pageNumber += 1;
            return getItems($filter("formatArgs")(listingOptions.url, listingParams)).then(function (fetchedItems) {
              items.prefetchItems = fetchedItems;
            });
          }

          function getMoreItems(itemIndex) {
            if (!isNaN(itemIndex) && items.currentItems.Data.length > itemIndex) {
              scrollToItem(itemIndex);
              return;
            }

            if (items.currentItems.Remaining <= 0) {
              return;
            }

            rebuildItemsArray();
            getPrefetchItems().then(function () {
              if (!isNaN(itemIndex)) {
                getMoreItems(itemIndex);
              }
            });
          }

          function rebuildItemsArray() {
            var mergedItems = items.currentItems.Data.concat(items.prefetchItems.Data);

            items.currentItems = items.prefetchItems;
            items.currentItems.Data = mergedItems;

            ctl.items = items.currentItems;
          }

          function scrollToItem(itemIndex) {
            if ("scrollRestoration" in history) {
              history.scrollRestoration = "manual";
            }

            var $result = angular.element(".ty-press-listing-results__result:eq(" + itemIndex + ")");
            angular.element("html, body").scrollTop($result.offset().top);
          }

          // Analytics
          function triggerNewsLinkAnalytics($item, newsItem) {
            var currentItemText = angular.element($item).text();
            $analytics.eventTrack("selectedNews", {
              eventType: "click",
              category: "link",
              label: currentItemText + ":" + newsItem.Title,
            });
          }

          function triggerNewsLazyLoadAnalytics() {
            $analytics.eventTrack("showMoreNewsItems", {
              eventType: "click",
              category: "Lazy Loading",
              label: "",
            });
          }
          // End Analytics

          /*
           * ****************************************************
           * External functions.
           * ****************************************************
           */

          ctl.getMoreItems = function () {
            if (ctl.items.Remaining === 0) {
              ctl.busy = true;
              return;
            }

            triggerNewsLazyLoadAnalytics();
            getMoreItems();
          };

          ctl.getInitialItems = function () {
            init();
          };

          ctl.onItemClick = function ($event, item) {
            triggerNewsLinkAnalytics($event.currentTarget, item);
            location.hash = ctl.items.Data.indexOf(item);
          };
        },
      ];

      return {
        scope: true,
        restrict: "AE",
        replace: "true",
        controller: controller,
        controllerAs: "plc",
        bindToController: true,
      };
    },
  ]);
})(window.angular, window.parseInt, window.location, window.history, window.ToyotaConsts);
